import { z } from "zod";
import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils/httpCommon";
import { useApiUrls } from "../../useApiUrl";
import { allowedLaneTypes } from "../../../types/outbound/lane.type";

const laneSchema = z.object({
  laneId: z.number().positive(),
  laneType: z.enum(allowedLaneTypes),
  originSic: z.string().min(1),
  destinationSic: z.string().min(1),
  transitionDays: z.number().optional().nullable(),
});

const lanesResponseSchema = z.array(laneSchema);

export type GetLanesResponse = z.infer<typeof lanesResponseSchema>;

const keys = {
  outboundLanes: (sicCode: string) => ["outbound", "lanes", sicCode],
};

export function useGetLanes(sicCode: string) {
  const urls = useApiUrls();

  return useQuery({
    queryKey: keys.outboundLanes(sicCode),
    queryFn: async () => {
      const { data } = await http.get<GetLanesResponse>(urls.getLanes(sicCode));
      return lanesResponseSchema.parse(data);
    },
    select: (data) => [
      ...data
        .sort((a, b) => (a.laneId > b.laneId ? 1 : -1))
        .sort((a, b) => a.destinationSic.localeCompare(b.destinationSic)),
    ],
  });
}
